import { ref } from 'vue'
import PContextMenu from '../PContextMenu.vue'

type RegisteredInstance = {
  uid: number
  exposed: Record<string, unknown> | null
}

const instances = ref<RegisteredInstance[]>([])

export const useRegisterInstance = () => {
  const register = (instance: RegisteredInstance): void => {
    instances.value.push(instance)
  }

  const unregisterExcept = (instance: RegisteredInstance): void => {
    instances.value
      .filter((i) => i.uid !== instance.uid)
      .forEach((i) => {
        if (!i.exposed || !('close' in i.exposed)) {
          return
        }

        const componentInstance = i.exposed as unknown as InstanceType<typeof PContextMenu>

        componentInstance.close()
      })
  }

  return {
    register,
    unregisterExcept,
  }
}
